

import { ContainerNew } from '../../../dashboard/pages/home-new/styled'
import Table from '../../components/tailwind/table'


const HomeNew = () => {


    return (

        <>
            {/* <ModalInforVideo visible={visibleModalInfor} setVisibleModal={setVisibleModalInfor} video={`https://www.youtube.com/embed/${language.data == "es" ? "XQaU_7MrLGs" : "v3XLEG9-82c"}`} /> */}
            <ContainerNew>
                <Table />
            </ContainerNew>

        </>
    )
}

export default HomeNew